export function stripNonAscii(input) {
    return input.replace(/[^\x00-\x7F]/g, "");
}